import { AdminCredentialsSection } from "PFApp/profiles/edit/sections/admin_credentials_section";
import { AvailabilitySectionWrapper } from "PFApp/profiles/edit/sections/availability_section";
import CalendarsSection from "PFApp/profiles/edit/sections/calendars_section";
import { ContactInformationSection } from "PFApp/profiles/edit/sections/contact_information_section";
import CredentialsSection from "PFApp/profiles/edit/sections/credentials_section";
import DeleteUserSection from "PFApp/profiles/edit/sections/delete_user_section";
import DetailsSection from "PFApp/profiles/edit/sections/details_section";
import { NotificationsSection } from "PFApp/profiles/edit/sections/notifications_section";
import { PositionsSection } from "PFApp/profiles/edit/sections/positions/positions_section";
import useIsAvailabilityPermitted from "PFApp/use_is_availability_permitted";
import { FeatureFlag } from "PFCore/types/feature_flag";
import { Profile } from "PFTypes";

import { getProfileSectionText } from "./profile_edit_section_titles";
import { NavSection } from "./profile_edit_sections.types";
import { LanguageSettingsSection } from "./sections/language_settings/language_settings_section";

export const profileEditSections = (onShowTerms?: () => void): NavSection[] => [
  {
    section: "credentials",
    text: getProfileSectionText("credentials"),
    qaId: "credentials",
    component: CredentialsSection,
    requireFeature: FeatureFlag.PasswordSignin
  },
  {
    section: "notifications",
    text: getProfileSectionText("notifications"),
    qaId: "notifications-settings",
    component: NotificationsSection
  },
  {
    section: "language_settings",
    text: getProfileSectionText("language_settings"),
    qaId: "delete-user",
    component: LanguageSettingsSection
  },
  {
    section: "terms_and_conditions",
    text: getProfileSectionText("terms_and_conditions"),
    qaId: "terms_and_conditions",
    onClick: () => onShowTerms?.()
  },
  {
    section: "privacy_policy",
    text: getProfileSectionText("privacy_policy"),
    qaId: "privacy_policy",
    onClick: () => window.open("https://www.profinda.com/privacy-policy/", "_blank")
  },
  {
    section: "delete_user",
    text: getProfileSectionText("delete_user"),
    qaId: "delete-user",
    component: DeleteUserSection,
    danger: true,
    requireFeature: FeatureFlag.SelfInactivation
  }
];

export const adminProfileEditSections = (profile?: Profile): NavSection[] => {
  /* @ts-ignore */
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isAvailabilityPermitted = useIsAvailabilityPermitted(profile);

  return [
    {
      section: "details",
      text: getProfileSectionText("details"),
      qaId: "basic-info",
      component: DetailsSection
    },
    {
      section: "availability",
      icon: "calendar",
      text: getProfileSectionText("availability"),
      qaId: "availability",
      component: AvailabilitySectionWrapper,
      isVisible: () => isAvailabilityPermitted
    },
    {
      section: "positions",
      text: getProfileSectionText("positions"),
      qaId: "positions",
      component: PositionsSection
    },
    {
      section: "contact_information",
      text: getProfileSectionText("contact_information"),
      qaId: "contact-info",
      component: ContactInformationSection
    },
    {
      section: "admin_credentials",
      text: getProfileSectionText("admin_credentials"),
      qaId: "admin_credentials",
      component: AdminCredentialsSection
    },
    {
      section: "calendars",
      text: getProfileSectionText("calendars"),
      qaId: "calendars",
      component: CalendarsSection
    }
  ];
};
